import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/layout',
      name: 'home',
      component: ()=>import('../views/Layout/index.vue'),
      children: [
        {
          path: '/taskIndex',
          name: 'taskIndex',
          component: () => import('../views/Task/index.vue'),
        },
        {
          path: '/',
          name: 'taskIndex',
          component: () => import('../views/Task/index.vue'),
        },
        {
          path: '/taskOverview',
          name: 'taskOverview',
          component: () => import('../views/Task/overview.vue'),
        },
        {
          path: '/userMgmt',
          name: 'userMgmt',
          component: () => import('../views/settings/userMgmt.vue'),
        },
        {
          path: '/deptMgmt',
          name: 'deptMgmt',
          component: () => import('../views/settings/deptMgmt.vue'),
        },
        {
          path: '/roleMgmt',
          name: 'roleMgmt',
          component: () => import('../views/settings/roleMgmt.vue'),
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: ()=>import('../views/Login/login.vue'),
    },
    {
      path: '/',
      name: 'login',
      component: ()=>import('../views/Login/login.vue'),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js